import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';
import './Stepper.less';

function Stepper({stepperProps}){
  const steps = stepperProps.map((step, i) => (
      <Step
        key={step.id}
        id={step.id}
        label={step.label}
        status={step.status}
        number={i + 1}
        hasConnector={i > 0}
      />
    ));

  return (
    <div className='Stepper'>
      {steps}
    </div>
  );
}

Stepper.propTypes = {
  stepperProps: PropTypes.arrayOf(PropTypes.shape({
    status: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
};

export default Stepper;
